var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.667px",
    height: "14.958px",
    viewBox: "0 0 15.667 14.958",
    enableBackground: "new 0 0 15.667 14.958",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    d: "M12.209,14.582 c1.748,0,3.166-1.418,3.166-3.166V3.499c0-1.749-1.418-3.167-3.166-3.167H9.041c-1.748,0-3.166,1.418-3.166,3.167 c0,0.438,0.354,0.792,0.792,0.792c0.438,0,0.792-0.354,0.792-0.792c0-0.875,0.708-1.583,1.582-1.583h3.168 c0.874,0,1.582,0.708,1.582,1.583v7.917c0,0.875-0.708,1.582-1.582,1.582H9.041c-0.874,0-1.582-0.707-1.582-1.582 c0-0.438-0.355-0.793-0.792-0.793c-0.437,0-0.792,0.355-0.792,0.793c0,1.748,1.418,3.166,3.166,3.166H12.209z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.834,6.666 c0.437,0,0.791,0.354,0.791,0.792c0,0.438-0.354,0.792-0.791,0.792H3.023L4.62,9.824l-1.113,1.127L0.569,8.049 C0.419,7.903,0.334,7.701,0.333,7.491C0.332,7.281,0.414,7.08,0.562,6.93l2.931-2.968L4.62,5.075l-1.571,1.59H9.834z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutProfile);
export default __webpack_public_path__ + "static/media/logoutProfile.c39864a1d4e5b55206c7eae7d8620b53.svg";
export { ForwardRef as ReactComponent };